import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/UserArrowRotate.svg'

export const IconUserArrowRotate = IconSVG as IconComponent
